import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getGladeStudentDetail } from "../../api/server";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import AddInfoMultistep from "./add-info-multistep";

const GladeBudgetAnalysisAdminEdit = () => {
  const location = useLocation();
  const clientId = new URLSearchParams(location.search).get("id");
  const [clientName, setClientName] = useState("");

  useEffect(() => {
    if (!clientId) return;

    let isActive = true;
    getGladeStudentDetail(clientId)
      .then((response) => {
        const enrollment = response.data?.result?.enrollment;
        const name = `${enrollment?.firstName || ""} ${
          enrollment?.lastName || ""
        }`.trim();
        if (isActive) setClientName(name);
      })
      .catch(() => {
        if (isActive) setClientName("");
      });

    return () => {
      isActive = false;
    };
  }, [clientId]);

  return (
    <div className="wrapper">
      <DashBoardSidebar />
      <div id="content">
        <DashboardNavbar />
        <div className="glade-detail-toolbar">
          <h1>
            {clientName ? `${clientName} (Glade) Budget Analysis` : "Glade Budget Analysis"}
          </h1>
          <Link
            className="btn_brnd-outline"
            to={`/glade-client-details?id=${encodeURIComponent(clientId || "")}`}
          >
            Back to Client Details
          </Link>
        </div>
        {clientId ? (
          <AddInfoMultistep
            embedded
            accountId={clientId}
            apiType="admin/glade"
            backToClientPath={`/glade-client-details?id=${encodeURIComponent(clientId)}`}
            summaryPath={`/glade-budget-analysis-report?id=${encodeURIComponent(clientId)}`}
          />
        ) : (
          <div className="glade-empty-state">Glade client ID is missing</div>
        )}
      </div>
    </div>
  );
};

export default GladeBudgetAnalysisAdminEdit;
